/* istanbul ignore file */
export default ({ palette }) => ({
  backgroundCard: palette.background,
  backgroundOverlay: 'rgba(0,0,0,0.25)',
  borderRadius: 3,
  btnCloseBackground: palette.grey.G300,
  cardDropShadow: { boxShadow: '0px 2px 6px rgba(0,0,0,0.2)' },
  cardWidth: 500,
  closeIconColor: palette.grey.G800,
  closeIconColorHover: palette.focus.normal,
  gripColor: palette.grey.G800,
  textColor: palette.grey.G500,
  card: {
    padding: 0,
    border: '1px solid #999'
  },
  header: {
    padding: [15, 20],
    backgroundColor: palette.grey.G100
  },
  content: {
    maxHeight: ({ maxContentHeight }) => maxContentHeight,
    padding: [24, 20]
  },
  primaryHeader: {
    fontSize: 14,
    fontWeight: '700',
    maxWidth: '100%',
    margin: 0,
    display: 'inline-block'
  },
  icon: {
    position: 'absolute',
    top: 17,
    left: 10
  },
  takeover: {
    padding: 0
  },
  btnClose: {
    background: 'transparent',
    position: 'absolute',
    right: 0,
    top: 0,
    border: 0,
    cursor: 'pointer',
    margin: [15],
    '& svg': { fill: palette.grey.G300 },
    '&:hover': {
      '& svg': { fill: palette.grey.G800 }
    }
  },
  errorModal: {
    '&$header': {
      backgroundColor: '#FECCCD',
      paddingLeft: 33
    },
    '& $icon svg, & $btnClose svg': {
      fill: palette.error
    }
  },
  warningModal: {
    '&$header': {
      backgroundColor: '#FFF7D7',
      paddingLeft: 33
    },
    '& $icon svg, & $btnClose svg': {
      fill: '#eba10e'
    }
  },
  successModal: {
    '&$header': {
      backgroundColor: '#DFF0D6',
      paddingLeft: 33
    },
    '& $icon svg, & $btnClose svg': {
      fill: '#8CB566'
    }
  },
  infoModal: {
    '&$header': {
      backgroundColor: palette.primary.light,
      paddingLeft: 33
    },
    '& $icon svg, & $btnClose svg': {
      fill: palette.info
    }
  },
  actions: {
    padding: 20
  }
});
